import { get } from '../../../utils/get';
import { buildOgImagePreview } from '../../../utils/build-og-image';
export var getMainImageUrl = function (item) {
    if (item === void 0) { item = {}; }
    return item.challenge &&
        buildOgImagePreview(get(item, 'challenge.mainImage.id'), get(item, 'challenge.mainImage.width'), get(item, 'challenge.mainImage.height'), 'fill');
};
